<template>
  <div>
    <vl-map
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      style="height: 450px"
      ref="map"
      @click="mapClicked"
    >
      <vl-view
        :zoom.sync="mapZoom"
        :maxZoom="maxZoom"
        :minZoom="minZoom"
        :center.sync="mapCenter"
        :rotation.sync="rotation"
        ref="mapView"
      ></vl-view>
      <vl-layer-tile>
        <vl-source-xyz :url="url"></vl-source-xyz>
      </vl-layer-tile>
      <vl-overlay
        v-if="this.showPlaceInfo == true && this.mapZoom > 12"
        id="overlay"
        :position="showPlaceCoord"
      >
        <template slot-scope="scope">
          <div class="overlay-content">
            <div v-if="selectedAssets.length > 0">
              <img
                :src="selectedAssets[0].photoUrl"
                alt="place"
                width="250px"
                height="120px"
                align="center"
              />
            </div>
            <h4>{{ selectedTitle }}<br /></h4>
            {{ selectedText }}<br />
          </div>
        </template>
      </vl-overlay>
      <vl-feature v-if="selectedCoords && showType == 'locSelect'">
        <vl-geom-point :coordinates="selectedCoords"> </vl-geom-point>
        <vl-style-box>
          <!-- <vl-style-circle :radius="6">
            <vl-style-fill color="white"></vl-style-fill>
            <vl-style-stroke color="red"></vl-style-stroke>
          </vl-style-circle> -->
          <vl-style-icon
            :src="require('@/assets/marker-green.png')"
            :scale="0.035"
            :anchor="[0.5, 1]"
          ></vl-style-icon>
        </vl-style-box>
      </vl-feature>
      <!-- {{ clickCoord }} -->
      <vl-layer-vector :zIndex="1">
        <vl-feature
          id="line-string"
          :properties="{ prop: 'value', prop2: 'value' }"
        >
          <vl-geom-line-string
            v-if="route.length > 0"
            :coordinates="JSON.parse(route[0].geoJson).coordinates"
          ></vl-geom-line-string>
          <vl-style-box>
            <vl-style-fill :width="5" color="red"></vl-style-fill>
            <vl-style-stroke :width="5" color="red"></vl-style-stroke>
          </vl-style-box>
        </vl-feature>
      </vl-layer-vector>

      <vl-layer-vector
        render-mode="image"
        id="points"
        :visible="visibleLayer === 'points'"
      >
        <div v-if="route.length == 0">
          <vl-source-cluster :distance="40">
            <vl-source-vector
              :zIndex="10000"
              ref="geojsonSource"
              :features.sync="points"
            ></vl-source-vector>
            <!-- <vl-style-box>
              <vl-style-icon :src="this.points.properties.icon" :scale="0.1" />
              <vl-style-text text="Hola" font="14px monospace"></vl-style-text>
            </vl-style-box> -->
            <vl-style-func :factory="makeClusterStyleFunc"></vl-style-func>
          </vl-source-cluster>
        </div>
        <div v-else>
          <vl-source-vector
            ref="geojsonSource"
            :features.sync="points"
          ></vl-source-vector>
          <vl-style-box>
            <vl-style-icon
              :src="require('@/assets/marker-green.png')"
              :scale="0.028"
            />
            <!-- <vl-style-circle :radius="5">
              <vl-style-fill color="white"></vl-style-fill>
              <vl-style-stroke color="red"></vl-style-stroke>
            </vl-style-circle> -->
          </vl-style-box>
        </div>
      </vl-layer-vector>
    </vl-map>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "ol/ol.css";
import { Fill, Stroke, Style, Circle, Text, Icon } from "ol/style";

export default {
  props: {
    categoryId: String,
    showPoints: Object,
    showType: String,
    mapCenter: Array,
    mapZoom: Number,
    showPlaceInfo: Boolean,
    showPlaceCoord: Array,
    selectedPlace: Object,
    selectedAssets: Array,
    selectedTitle: String,
    selectedText: String,
    selectedCoords: Array,
  },
  watch: {
    categoryId: function () {
      this.getRoutes();
    },
    dark: function () {
      console.log("dark changed");
      if (this.dark) {
        this.url =
          process.env.VUE_APP_MAP_ENDPOINT +
          "/styles/dark-matter/{z}/{x}/{y}@2x.png";
      } else {
        this.url =
          process.env.VUE_APP_MAP_ENDPOINT +
          "/styles/basic-preview/{z}/{x}/{y}@2x.png";
      }
    },
    showPoints: async function () {
      this.points = [];
      this.showPoints.map((position) => {
        if (this.showType == "incidents") {
          this.points.push({
            properties: {
              icon: position.incidentType.iconUrl,
            },
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [parseFloat(position.lon), parseFloat(position.lat)],
            },
          });
        } else if (this.showType == "issues") {
          if (position.lat != null) {
            this.points.push({
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [position.lon, position.lat],
              },
            });
          }
        } else {
          this.points.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [parseFloat(position.lon), parseFloat(position.lat)],
            },
          });
        }
      });
    },
    points: async function () {
      setTimeout(() => {
        this.$refs.mapView.$view.fit(
          this.$refs.geojsonSource.$source.getExtent(),
          {
            size: this.$refs.map.$map.getSize(),
            duration: 500,
          }
        );
      }, 1);
    },
  },
  data() {
    return {
      zoom: 9,
      maxZoom: 22,
      minZoom: 6,
      center: [],
      rotation: 0,
      geolocPosition: undefined,
      url: "",
      categoryIds: [],
      points: [],
      clickCoord: null,
    };
  },
  async created() {
    console.log("routes are refreshing due to creating");
    if (this.dark) {
      this.url =
        process.env.VUE_APP_MAP_ENDPOINT +
        "/styles/dark-matter/{z}/{x}/{y}@2x.png";
    } else {
      this.url =
        process.env.VUE_APP_MAP_ENDPOINT +
        "/styles/basic-preview/{z}/{x}/{y}@2x.png";
    }
    await this.getRoutes();
  },
  computed: {
    ...mapGetters({ dark: "app/dark" }),
    ...mapGetters({ route: "route/items" }),
    // ...mapGetters({ places: "places/items" }),

    visibleLayer() {
      return this.mapZoom <= 7 ? "lines" : "points";
    },
  },
  methods: {
    ...mapActions(["route/getItems"]),

    async getRoutes() {
      this.categoryIds.push(this.categoryId);
      await this.$store.dispatch("route/getItems", this.categoryIds);
      this.categoryIds.splice(0, this.categoryIds.length);
    },
    mapClicked(evt) {
      this.selectedCoords = evt.coordinate;
      this.$emit(
        "locSelected",
        this.selectedCoords,
        this.$refs.map.$map.getView().getZoom()
      );
    },

    makeClusterStyleFunc() {
      return (feature) => {
        if (this.showType != "incidents") {
          return new Style({
            image: new Circle({
              fill: new Fill({ color: "#fff" }),
              stroke: new Stroke({ color: "blue", width: 5 }),
              radius: 10,
            }),
            text: new Text({
              text: String(feature.get("features").length),
            }),
          });
        } else {
          return new Style({
            image: new Icon({
              src: feature.getProperties().features[0].values_.icon,
              scale: 0.2,
            }),
          });
        }
      };
    },
  },
};
</script>

<style>
.overlay-content {
  background: #fcd0d0;
  box-shadow: 0 5px 10px rgb(2 2 2 / 20%);
  padding: 10px 20px;
  font-size: 14px;
  width: 300px;
}
</style>